<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-widget>
        <div class="va-row">
          <div class="flex">
            <button class="btn btn-primary btn-micro"
                    @click="newUserData">
              {{ "basic.button.confirm" | translate }}
            </button>
          </div>
          <div class="flex">
            <button class="btn btn-pale btn-micro"
                    @click="$router.back(-1)">
              {{ "basic.button.cancel" | translate }}
            </button>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="va-row">
      <div class="flex md12 xs12">
        <!-- User Infomation -->
        <vuestic-widget :headerText="'userManagement.user.userInfomation.title' | translate">
          <fieldset>
            <div class="va-row">
              <!-- Name -->
              <div class="flex md6">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      id="new_user_name"
                      v-model.trim="userForm.name"
                      maxlength="128"
                      required
                    />
                    <label class="control-label" for="new_user_name">{{
                      "userManagement.user.userInfomation.name" | translate
                    }}</label><i class="bar"></i>
                  </div>
                </div>
              </div>
              <!-- Email TODO增加对邮箱的校验-->
              <div class="flex md6">
                <div class="form-group with-icon-right"
                     :class="{
                    'has-error': errors.has('userEmail'),
                    valid: simpleEmailValid
                  }">
                  <div class="input-group">
                    <input
                      id="new_user_email"
                      name="userEmail"
                      autocomplete="off"
                      maxlength="100"
                      @focus="changeLabelUp"
                      @blur="changeLabelBase"
                      v-model.trim="userForm.email"
                      v-validate="'email|validateEmail'"
                    />
                    <i
                      class="fa fa-exclamation-triangle error-icon icon-right input-icon"
                    ></i>
                    <!-- <i class="fa fa-check valid-icon icon-right input-icon"></i> -->
                    <label id="newEmail"
                           class="control-label"
                           for="userEmail">
                      {{
                        "userManagement.user.userInfomation.email" | translate
                      }}：
                    </label>
                    <i class="bar" />
                    <small v-show="errors.has('userEmail')"
                           class="help text-danger">
                      {{ errors.first("userEmail") }}
                    </small>
                  </div>
                </div>
              </div>

              <!-- Password -->
              <div class="flex md6">
                <div class="form-group" style="margin-bottom: 0;">
                  <div class="input-group">
                    <input
                      id="new_user_password"
                      :type="isNewOpen?'text':'password'"
                      maxlength="50"
                      v-model="userForm.password"
                      required
                      @keydown="e =>{if(e.keyCode == 32) e.returnValue = false;}"
                      onkeyup="value=value.replace(/\s/g,'')"
                      onkeydown="value=value.replace(/\s/g,'')"
                    />
                    <label class="control-label" for="new_user_password">{{
                      "userManagement.user.userInfomation.password" | translate
                    }}</label><i class="bar"></i>
                    <div class="eye-password">
                      <img :src="closeEye" alt="" @click="() => { isNewOpen = true }" v-if="!isNewOpen"/>
                      <img :src="openEye" alt="" @click="() => { isNewOpen = false }" v-if="isNewOpen"/>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Repeat Password -->
              <div class="flex md6">
                <div class="form-group" style="margin-bottom: 0;">
                  <div class="input-group">
                    <input
                      id="new_user_repeat_password"
                      :type="isRepOpen?'text':'password'"
                      maxlength="50"
                      v-model="userForm.repeat_password"
                      required
                      @keydown="e =>{if(e.keyCode == 32) e.returnValue = false;}"
                      onkeyup="value=value.replace(/\s/g,'')"
                      onkeydown="value=value.replace(/\s/g,'')"
                    />
                    <label
                      class="control-label"
                      for="new_user_repeat_password"
                      >{{
                        "userManagement.user.userInfomation.repeat_password"
                          | translate
                      }}</label><i class="bar"></i>
                      <div class="eye-password">
                      <img :src="closeEye" alt="" @click="() => { isRepOpen = true }" v-if="!isRepOpen"/>
                      <img :src="openEye" alt="" @click="() => { isRepOpen = false }" v-if="isRepOpen"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group with-icon-right" style="margin-left:10px;">
                {{ $t('t.passwordMustBe') }}
              </div>
            </div>
          </fieldset>
        </vuestic-widget>

        <!-- Authority -->
        <vuestic-widget :headerText="'userManagement.user.authority.title' | translate"
                        id="formAuthority">
          <fieldset>
            <!-- Pages -->
            <div class="flex md12 xs12">
              <div style="border-width: 0px 0px 1px 0px; border-style: solid; border-color: rgba(204, 204, 204, 1);">
                <span>{{
                  "userManagement.user.authority.pages.title" | translate
                }}</span>
              </div>
            </div>
            <div class="flex md12 xs12"
                 v-for="(page, index) in userForm.pages"
                 :key="index">
              <!-- Page List -->
              <div class="va-row">
                <!-- <div class="flex md2" /> -->
                <div class="flex md4 p-l">
                  <label>{{ translatePageName(page.name) }}</label>
                </div>
                <div class="flex md2" />
                <div class="flex md4">
                  <!-- <el-checkbox-group v-model="userForm.pages[index].privileges">
                  <el-checkbox-button border v-for="p in privilege" :label="p" :key="p">{{p}}</el-checkbox-button>
                </el-checkbox-group> -->
                  <vuestic-checkbox :label="$t('view')"
                                    style="display:inline-flex;width:100px;"
                                    v-model="createItems[index].privileges[0]" />
                  <!-- <vuestic-checkbox
                  label="Edit"
                  style="display:inline-flex;"
                  v-model="createItems[index].privileges[1]"
                /> -->
                </div>
                <div class="flex md2" />
              </div>
            </div>

            <!-- APPs -->
            <div class="flex md12 xs12">
              <div style="border-width: 0px 0px 1px 0px; border-style: solid; border-color: rgba(204, 204, 204, 1);">
                <span>{{
                  "userManagement.user.authority.apps.title" | translate
                }}</span>
              </div>
            </div>
            <div class="va-row">
              <div class="flex md1 xs1"></div>
              <!-- APP List -->
              <div class="flex md10 xs10">
                <vuestic-multi-select :label="$t('userManagement.user.authority.apps.selectDuplicate')"
                                      v-model="selectApps"
                                      optionKey="app_name"
                                      clearable
                                      :options="appList" />
                <!-- <el-checkbox-group v-model="userForm.linked_apps" class="p-l">
                <el-checkbox v-for="app in appList" :label="app.app_id" :key="app.app_id">{{app.app_name}}</el-checkbox>
              </el-checkbox-group> -->
                <div class="flex md1 xs1"></div>
              </div>
            </div>
          </fieldset>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/utils/utils";
import { translatePageName as mapPageName } from "@/utils/pageNameLabel";
import pageName from "./pageNames";
export default {
  name: "NewUser",
  data() {
    const that = this
    var Reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    that.$validator.extend('validateEmail', {
      validate: (value, ref) => {
        if (!Reg.test(that.userForm.email)) {
          return false
        } else {
          return true
        }
      },
      getMessage: (field) => 'Please enter the correct email address!'
    })
    return {
      userForm: {
        name: "",
        email: "",
        password: "",
        repeat_password: "",
        pages: [
          // {
          //   name: pageName.transactions,
          //   privileges: [""],
          // },
          {
            name: pageName.report,
            privileges: [""],
          },
          {
            name: pageName.appManagement,
            privileges: [""],
          },
          {
            name: pageName.finance,
            privileges: [""],
          },
          {
            name: pageName.virtualAccount,
            privileges: [""]
          },
          // {
          //   name: pageName.merchantKyc,
          //   privileges: [""],
          // },
          {
            name: pageName.wayBill,
            privileges: [""],
          },
          {
            name: pageName.download,
            privileges: [""],
          },
        ],
        linked_apps: [],
      },
      appList: [],
      selectApps: [],
      privilege: ["View", "Edit"],
      createItems: [
        // {
        //   name: pageName.transactions,
        //   privileges: [false, false],
        // },
        {
          name: pageName.report,
          privileges: [false, false],
        },
        {
          name: pageName.appManagement,
          privileges: [false, false],
        },
        {
          name: pageName.finance,
          privileges: [false, false],
        },
        {
          name: pageName.virtualAccount,
          privileges: [false, false]
        },
        // {
        //   name: pageName.merchantKyc,
        //   privileges: [false, false],
        // },
        {
          name: pageName.wayBill,
          privileges: [false, false],
        },
        {
          name: pageName.download,
          privileges: [false, false],
        },
      ],
      closeEye: require('@/assets/images/eye-close.png'),
      openEye: require('@/assets/images/eye-open.png'),
      isNewOpen: false,
      isRepOpen: false,
    };
  },
  beforeMount() {
    if (process.env.VUE_APP_WEBSETE_SIGN === 'lt') {
      this.userForm.pages = this.userForm.pages.filter(page => (page.name !== pageName.virtualAccount && page.name !== pageName.wayBill))
    }
  },
  mounted() {
    this.getAppList();
  },
  watch: {
    selectApps(apps) {
      this.userForm.linked_apps = [];
      apps.forEach((item, i) => {
        this.userForm.linked_apps.push(item.app_id);
      });
    },
  },
  methods: {
    translatePageName(name) {
      return mapPageName(this, name);
    },
    getAppList() {
      let token = localStorage.getItem("Authorization");
      let urls = "api/dashboard/merchant/getMerchantInfo?access_token=" + token;
      request({
        method: "post",
        url: urls,
      }).then((res) => {
        this.appList = res.data.app_list;
      });
    },
    simpleEmailValid() {
      let isValid = false;
      if (this.formFields.userEmail) {
        isValid =
          this.formFields.userEmail.validated &&
          this.formFields.userEmail.valid;
      }

      return isValid;
    },
    convertBoolToStr() {
      let cloneObj = [].concat(JSON.parse(JSON.stringify(this.createItems)));
      cloneObj = cloneObj.map((item, index, arr) => {
        item.privileges[0]
          ? (item.privileges[0] = "View")
          : (item.privileges[0] = "");
        item.privileges[1]
          ? (item.privileges[1] = "Edit")
          : (item.privileges[1] = "");
        return item;
      });
      return cloneObj;
    },
    getInitFormItems() {
      let BoolItems = [
        // { name: pageName.transactions, privileges: [false, false] },
        { name: pageName.report, privileges: [false, false] },
        { name: pageName.appManagement, privileges: [false, false] },
        { name: pageName.finance, privileges: [false, false] },
        { name: pageName.virtualAccount, privileges: [false, false] },
        // { name: pageName.merchantKyc, privileges: [false, false] },
        { name: pageName.wayBill, privileges: [false, false] },
        { name: pageName.download, privileges: [false, false] },
      ];
      this.createItems = [...BoolItems];
      let formObj = {
        name: "",
        email: "",
        password: "",
        repeat_password: "",
        pages: [
          // { name: pageName.transactions, privileges: [""] },
          { name: pageName.report, privileges: [""] },
          { name: pageName.appManagement, privileges: [""] },
          { name: pageName.finance, privileges: [""] },
          { name: pageName.virtualAccount, privileges: [""] },
          // { name: pageName.merchantKyc, privileges: [""] },
          { name: pageName.wayBill, privileges: [""] },
          { name: pageName.download, privileges: [""] },
        ],
        linked_apps: [],
      };
      this.userForm = { ...formObj };
    },
    changeLabelUp() {
      document.getElementById("newEmail").className = "control-label2";
    },
    changeLabelBase() {
      if (!document.getElementById("new_user_email").value) {
        document.getElementById("newEmail").className = "control-label";
      } else {
        document.getElementById("newEmail").className = "control-label2";
      }
    },
    checkSomeVal(data) {
      data.privileges.some(function (val) {
        return val !== "";
      });
    },
    newUserData() {
      // console.log("调试点击创建用户--》");
      this.userForm.pages = [...this.convertBoolToStr()];
      let bol = [];
      for (let i = 0; i < this.userForm.pages.length; i++) {
        for (let j = 0; j < 2; j++) {
          if (this.userForm.pages[i].privileges[j] !== "") {
            bol.push(true);
          }
        }
      }
      /* if(bol.includes(true) === false) {
        return;
      } */
      if (_.trim(this.userForm.name) === "") {
        this.$message({
          message: "Name can not be empty!",
          type: "warning",
        });
        return;
      }
      if (_.trim(this.userForm.email) === "") {
        this.$message({
          message: "E-mail can not be empty!",
          type: "warning",
        });
        return;
      }
      var Reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!Reg.test(this.userForm.email)) {
        this.$message({
          message: "Please enter the correct email address!",
          type: "warning",
        });
        return;
      }
      if (_.trim(this.userForm.password) === "") {
        this.$message({
          message: "Password can not be empty!",
          type: "warning",
        });
        return;
      }
      if (_.trim(this.userForm.repeat_password) === "") {
        this.$message({
          message: "Repeat password cannot be empty!",
          type: "warning",
        });
        return;
      }
      if (this.userForm.password != this.userForm.repeat_password) {
        this.$message({
          message: "Two passwords are inconsistent!",
          type: "warning",
        });
        return;
      }
      // 校验密码的复杂度
      let regExpPassword = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*-])[A-Za-z\\d!@#$%^&*-]{8,}$")
      if (!regExpPassword.test(this.userForm.password)) {
        this.$message({
          message: this.$t('t.newPasswordMustBe'),
          type: "warning",
        });
        return;
      }

      let data = JSON.stringify(this.userForm);
      let token = localStorage.getItem("Authorization");
      let self = this;

      request({
        method: "put",
        url: "api/dashboard/app/user/add?access_token=" + token,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      }).then((res) => {
        if (res.data.code == 10000) {
          //alert(self.userForm.name + ' Created!')
          this.$message({
            duration: 1200,
            message: self.userForm.name + " Created!",
            type: "success",
          });
          self.getInitFormItems();
          self.$router.push({
            name: "UserManagement",
          });
        } else if (res.data.code == 20000) {
          //alert('Failed to create ' + self.userForm.name + ', please try again');
          this.$message({
            duration: 1200,
            message:
              "Failed to create " + self.userForm.name + ", please try again",
            type: "error",
          });
        } else {
          //alert(self.userForm.name + ' cannot be created, ' + res.data.msg);
          this.$message({
            duration: 1200,
            message: self.userForm.name + " cannot be created, " + res.data.msg,
            type: "error",
          });
        }
        self.getInitFormItems();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.p-l {
  padding-left: 40px !important;
}
/deep/ .el-checkbox__label {
  font-size: 1rem;
}
/deep/ .el-checkbox__inner {
  width: 22px;
  height: 22px;
  border-radius: 0.25rem;
  border: solid 0.125rem #acb5be;
  &:hover {
    border-color: #acb5be;
  }
  &::after {
    position: absolute;
    top: 2px;
    left: 6px;
    width: 5px;
    height: 9px;
    border-width: 2px;
  }
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ae387;
  border-color: #4ae387;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
  font-weight: 500;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #acb5be;
}
/deep/ .valid.form-group .control-label.control-label {
  color: #b3b3b3;
  position: absolute;
  top: 8px;
  text-transform: none;
  font-size: 16px;
  font-weight: normal;
  pointer-events: none;
}
.control-label2 {
  color: #4ae387;
  position: absolute;
  top: -10px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  pointer-events: none;
}
/* /deep/ .valid.form-group #newEmail.control-label.control-label {
  top: 0.25rem; // -10px;
  color: #b3b3b3; // #4ae387;
  font-size: 14px;
  font-weight: 600;
} */
@media only screen and (max-width: 750px) {
  /deep/ #formAuthority.vuestic-widget {
    .vuestic-widget-body {
      padding: 0.5rem;
      fieldset label {
        width: 120px;
        padding-left: 10px;
      }
    }
  }

  .p-l {
    padding-left: 0 !important;
  }
}
/deep/ .scrollbar-wrapper {
  height: 200px !important;
  overflow-y: scroll;
}
#formAuthority {
  padding-bottom: 80px;
}
.eye-password {
  position: absolute;
  top: 2px;
  right: 5px;
  width: 25px;
  cursor: pointer;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
